/// <amd-module name="Wit/BoardsHub/Common/StylesUtils" />
import { CardRule } from "Wit/BoardsHub/Common/Client/Contracts/Settings";
import { ICardStyle } from "Wit/ClientWorkItemService/IClientWorkItem";

export function divyCardRules(rules: CardRule[]): {
    annotations: CardRule[];
    cardStyles: CardRule[];
    tagStyles: CardRule[];
    swimlaneRules: CardRule[];
} {
    const cardStyles: CardRule[] = [];
    const tagStyles: CardRule[] = [];
    const annotations: CardRule[] = [];
    const swimlaneRules: CardRule[] = [];
    for (const rule of rules) {
        const type = rule.type;
        if (type === CardRuleTypes.TagStyle) {
            tagStyles.push(rule);
        } else if (type === CardRuleTypes.Fill) {
            // Fill type rule without criteria clauses is not valid, so just skip it as on OWP
            if (rule.criteria?.clauses) {
                cardStyles.push(rule);
            }
        } else if (type === CardRuleTypes.Annotation) {
            annotations.push(rule);
        } else if (type === CardRuleTypes.SwimlaneRule) {
            if (rule.criteria?.clauses) {
                swimlaneRules.push(rule);
            }
        }
    }

    return { annotations, cardStyles, tagStyles, swimlaneRules };
}

export function getCardStylesFromCardRules(cardRules: CardRule[]): ICardStyle[] {
    return cardRules.map(cardRule => ({
        name: cardRule.name,
        backgroundColor: (cardRule.style as any)["background-color"],
        titleStyle: {
            isTitleItalicized: (cardRule.style as any)["title-font-style"],
            isTitleBold: (cardRule.style as any)["title-font-weight"],
            isTitleUnderlined: (cardRule.style as any)["title-text-decoration"],
            titleColor: (cardRule.style as any)["title-color"]
        },
        clauses: cardRule.criteria.clauses,
        isEnabled: cardRule.isEnabled
    }));
}

export enum CardRuleTypes {
    Annotation = "annotation",
    Fill = "fill",
    TagStyle = "tagStyle",
    SwimlaneRule = "swimlaneRule"
}
